import { Injectable } from '@angular/core';
import { GlobalTrackingService } from '../../../SGRE-shared/services/global-tracking.service';
import { StorageService } from '../../../SGRE-shared/services/storage.service';
import { AuthService, LanguageService } from '@spartacus/core';
import { ActionType, Country, DocumentData, DocumentType, pageData, PageReadyData, userData } from '../../../SGRE-shared/models/global-tracking.model';
import { LoginStatus } from '../../../SGRE-shared/models/global-tracking.model';
import { Document } from '../model/user-page-model';
import { Router } from '@angular/router';
import { take } from 'rxjs';
import { Users } from '../../../SGRE-shared/models/trackingData.model';
import { LegalEntity } from '../../../SGRE-shared/models/legalEntityList.model';
import { AppConstants, pageIds } from '../../../SGRE-shared/constants/app-constant';

@Injectable({
  providedIn: 'root'
})
export class UsersTrackingService {

  constructor(
    private globalTrackingService: GlobalTrackingService,
    private storageService: StorageService,
    private authService: AuthService,
    private languageService: LanguageService,
    private router: Router
  ) { }

  pageLoadTrackingData(entity: LegalEntity): void {
    let loginStatus: string
    let language: string;
    this.authService.isUserLoggedIn().pipe(take(1)).subscribe((data) => loginStatus = data ? LoginStatus.LOGGED_IN : LoginStatus.LOGGED_OUT);
    this.languageService.getActive().pipe(take(1)).subscribe((lang) => language = lang);

    const pageData: pageData = {
      path: AppConstants.routeUrls.users,
      title: AppConstants.breadcrumbUrls[AppConstants.routeUrls.users.substring(1)] || '',
      language: language || '',
      country: Country.COUNTRY,
      template: pageIds.PID_15
    };

    const user: userData = {
      loginStatus: loginStatus,
      role: this.storageService?.userRoles || '',
      company: entity?.name || '',
      companyId: '',
    };

    const pageLoadData: PageReadyData = {
      page: pageData,
      user: user,
    };

    this.globalTrackingService.sendPageReadyData(ActionType.PAGE_READY, pageLoadData);
  }

  trackDocumentEvent(clickTarget?: HTMLElement): void {
    const documentData: DocumentData = {
      name: Document.NAME,
      id: '',
      type: DocumentType.TYPE,
      extension: DocumentType.EXTENSION,
      url: ''
    };
    const data = {
      document: documentData
    };

    this.globalTrackingService.sendTrackingEvent(ActionType.DOWNLOAD, data, clickTarget);
  }
}